import { Modal, ModalDialog, Typography, Table, IconButton, Tooltip } from '@mui/joy';
import RemoveShoppingCartOutlinedIcon from '@mui/icons-material/RemoveShoppingCartOutlined';
import { useUser } from '../../config/UserContext';

export default function CartCoursesError({
    open,
    onClose,
    cartErrorBoxMsg = '',
    cartErrorBoxList = [],
    onRemoveFromCart
}) {
    const { trainingProviders } = useUser();

    return (
        <Modal
            aria-labelledby="cart-error-modal"
            open={open}
            onClose={onClose}
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
            disableScrollLock={true}
        >
            <ModalDialog>
                <Typography
                    component="h2"
                    id="modal-title"
                    level="h5"
                    color='warning'
                    sx={{ fontWeight: 'lg', mb: 1 }}
                >
                    Warning! Equivalent course exists in Training Cart
                </Typography>

                <Table
                    borderAxis="xBetween"
                    size="sm"
                    variant="plain"
                    sx={{
                        borderRadius: '1.5px',
                        overflow: 'auto'
                    }}
                    hoverRow
                >
                    <thead>
                        <tr>
                            <th>Course Code</th>
                            <th>Version Code</th>
                            <th>Training Provider</th>
                        </tr>
                    </thead>
                    <tbody>
                        {cartErrorBoxList?.map((row) => (
                            <tr key={row.courseId || row.course_id}>
                                <td>{row.courseId || row.course_id}</td>
                                <td>{row.tp_course_code}</td>
                                <td>{trainingProviders?.[parseInt(row.tp_id || row.training_provider_id)]}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>

                <Typography level="body-sm" textColor="neutral" sx={{ mb: 2, textAlign: 'center' }}>
                    {cartErrorBoxMsg}
                    <br /><br />
                    <IconButton
                        color="primary"
                        variant='outlined'
                        onClick={onRemoveFromCart}
                        aria-label="remove-from-cart"
                        sx={{ ml: 1 }}
                        size='sm'
                    >
                        &nbsp; <RemoveShoppingCartOutlinedIcon />Replace with current selection in Cart &nbsp;
                    </IconButton>
                </Typography>
            </ModalDialog>
        </Modal>
    );
}